<template>
<div class="contact">
    <div v-if="isLoading">
        <div style="textAlign: center; fontSize: 27px; color: #719DF7; fontWeight: 400; marginBottom: 20px; marginTop: 30px;">Sending...</div>
        <div >
            <i class="el-icon-loading" style="fontSize: 80px; textAlign: center; color: #719DF7; width: 100%; margin: 50px auto;"></i>
        </div>
    </div>
    <div v-else-if="sentSuccess">
        <div style="textAlign: center; fontSize: 27px; color: #719DF7; fontWeight: 400; marginBottom: 20px; marginTop: 30px;">Success!</div>
        <div style="textAlign: center; fontSize: 25px; color: #719DF7; fontWeight: 400; marginBottom: 20px; marginTop: 20px;">We will be in touch with you shortly.</div>
        <div >
            <i class="el-icon-check" style="fontSize: 80px; textAlign: center; color: #719DF7; width: 100%; margin: 50px auto;"></i>
        </div>
    </div>
    <div v-else>
        <div style="textAlign: center; fontSize: 30px; color: #719DF7; fontWeight: 600; marginBottom: 20px;">Contact Us</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="90px" class="demo-ruleForm" style="width: 100%;">
            <el-form-item label="First Name" prop="first_name" required>
                <el-input v-model="ruleForm.first_name"></el-input>
            </el-form-item>
            <el-form-item label="Last Name" prop="last_name">
                <el-input v-model="ruleForm.last_name"></el-input>
            </el-form-item>
            <el-form-item label="Email" prop="email" required>
                <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="Phone" prop="phone">
                <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="Message" prop="message">
                <el-input type="textarea" v-model="ruleForm.message" :autosize="{ minRows: 5, maxRows: 6}"></el-input>
            </el-form-item>
            <el-form-item style="text-align: right;">
                <el-button type="primary" round @click="submitForm('ruleForm')">Submit <i class="el-icon-s-promotion"></i></el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>

export default {
  name: 'Contact',
  data() {
    return {
      ruleForm: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          message: '',
        },
        isLoading: false,
        sentSuccess: false,
    }
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.isLoading = true
                this.postData('https://gg47fvwak8.execute-api.us-east-2.amazonaws.com/y10a_active/contact')
            } else {
                return false;
            }
        });
    },
    postData(url) {
    // Default options are marked with *
    fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(this.ruleForm) // body data type must match "Content-Type" header
    }).then(data => {
        console.log(data)
        this.ruleForm = {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          message: '',
        }
        this.isLoading = false
        this.sentSuccess = true
    }).catch(err => {
        console.log(err)
        this.isLoading = false
    })
    }
  },
  computed: {
    add: function() {
      return this.num + 3
    }
  },
  created: function() {
    
  }

 
}
</script>

<style scoped lang="scss">
.contact {
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  background-color: white;
  height: 500px;
  width: 480px;
  border-radius: 20px;
  position: relative;
  left: 50px;
  margin-right: 30px;
}

@media (max-width: 500px) {
  .contact {
    width: 390px;
  }
}

@media (max-width: 1018px) {
    .contact {
        position: static;
        width: 370px;
        margin: 0 2px;
        margin-top: 30px;
    }
}


</style>
